/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_LedeInputs */

const tr_landing_pricing_lede = /** @type {(inputs: Landing_Pricing_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek abonelik, gelecek güncellemeler dahildir. İşletmenize uygun planı seçin.`)
};

const en_landing_pricing_lede = /** @type {(inputs: Landing_Pricing_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One subscription, every future update included. Choose the plan that fits your business.`)
};

const de_landing_pricing_lede = /** @type {(inputs: Landing_Pricing_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Abo, alle künftigen Updates inklusive. Wählen Sie den Plan, der zu Ihrem Unternehmen passt.`)
};

const ru_landing_pricing_lede = /** @type {(inputs: Landing_Pricing_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одна подписка, все будущие обновления включены. Выберите план, который подходит вашему бизнесу.`)
};

/**
* | output |
* | --- |
* | "One subscription, every future update included. Choose the plan that fits your business." |
*
* @param {Landing_Pricing_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_lede = /** @type {((inputs?: Landing_Pricing_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_lede(inputs)
	if (locale === "de") return de_landing_pricing_lede(inputs)
	if (locale === "ru") return ru_landing_pricing_lede(inputs)
	return tr_landing_pricing_lede(inputs)
});